import { FC, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useStoreState, useStoreDispatch, actionTypes } from '@/store'
import { DotLoading, AutoCenter } from 'antd-mobile'
import { useAuth } from '@eworld/uc-auth/packages/react'
import { PageLoading } from '@/components/PageLoading'


const isHw = process.env.REACT_APP_IDN_ENV === 'hw'

export const withAuth = (Component: FC) => {
  return props => {
    const { login, loading } = useAuth()
    const { user }: any = useStoreState();
    const dispatch = useStoreDispatch();
    const navigate = useNavigate();

    // 海外版本：未登录时重定向到首页，不自动弹登录弹窗
    useEffect(() => {
      if (isHw && !user.isLogin) {
        navigate('/');
      }
    }, [user.isLogin, navigate]);

    if (!user.isLogin) {
      // 海外版本：显示 Loading，等待重定向
      if (isHw) {
        return (
          <div style={{ 
            minHeight: '100vh', 
            display: 'flex', 
            alignItems: 'center',
            justifyContent: 'center' 
          }}>
            <AutoCenter>
              <DotLoading color='primary' />
            </AutoCenter>
          </div>
        );
      } else { // 国内登录直接跳转托管页
        if(!loading){
          login()
          return <Component {...props} />
        }
      }
    }

    return loading ? <PageLoading /> : <Component {...props} />
  }
}
